import { render, staticRenderFns } from "./ProductManager.vue?vue&type=template&id=195e536c&scoped=true"
import script from "./ProductManager.vue?vue&type=script&lang=js"
export * from "./ProductManager.vue?vue&type=script&lang=js"
import style0 from "./ProductManager.vue?vue&type=style&index=0&id=195e536c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e536c",
  null
  
)

export default component.exports